export default class RESTAPIConfig {

    private get protocol() {
        // return window.location.protocol;
        return "https";
    }

    private get host() {
        return `${window.location.hostname}:20443`;
        // if (window.location.hostname === "lk.inlab-genetics.ru") {
        //     return "b2b-inlab.com";
        // }
        // return "test.b2b-inlab.com";

        // return "lk.ralzo.ru";
        // return window.location.hostname;
    }

    public get apiPrefix() {
        return "/api";
    }

    public get apiPrefixV2() {
        return "/api/v2";
    }

    public get baseUrl() {
        // return `a0460902.xsph.ru`;
        return `${this.protocol}://${this.host}`;
    }

    public controlPanel() {
        return `/control-panel`;
    }

    // refactor
    public saveNewOrderForDNATest() {
        return `/create-new-order/save`;
    }

    // refactor
    public updateOrderForDNATest() {
        return `/order/update`;
    }

    public calculatePriceForDNATest() {
        return `/order/calculate`;
    }

    public calculateParticipant() {
        return "/order/participant/calculate";
    }

    public getCategoriesOfSamples() {
        return "/order/sample-type/list";
    }

    public getOrderPriceSettings() {
        return "/order/price-setting/list";
    }

    public finSourceList() {
        return "/fin/source/list";
    }

    public finUnusedSourceList() {
        return "/fin/source/unused-list";
    }

    public finSource() {
        return "/fin/source";
    }

    public finSourceById({id}: { id: number | string }) {
        return `/fin/source/${id}`;
    }

    public finRecalculatePartnerBalance() {
        return '/fin/balance/recalculate-partner';
    }

    public finWriteoffList() {
        return "/fin/writeoff/list";
    }

    public finWriteoff() {
        return "/fin/writeoff";
    }

    public finWriteoffById({id}: { id: number | string }) {
        return `/fin/writeoff/${id}`;
    }

    public finErrorList() {
        return "/fin/error/list";
    }

    public finErrorUnresolvedCount() {
        return "/fin/error/unresolved-count";
    }

    public finErrorById({errorId}: { errorId: number | string }) {
        return `/fin/error/${errorId}`;
    }

    public finErrorResolveType2({errorId}: { errorId: number | string }) {
        return `/fin/error/${errorId}/resolve-type-2`;
    }

    public finErrorResolveType3({errorId}: { errorId: number | string }) {
        return `/fin/error/${errorId}/resolve-type-3`;
    }

    public finErrorRecalculateBalance({errorId}: { errorId: number | string }) {
        return `/fin/error/${errorId}/recalculate-balance`;
    }

    public finErrorResolveType5({errorId}: { errorId: number | string }) {
        return `/fin/error/${errorId}/resolve-type-5`;
    }

    public finSourceTypesList() {
        return "/fin/source-types/list";
    }

    public finWriteoffTypesList() {
        return "/fin/writeoff-types/list";
    }

    public finFinancialStatusesList() {
        return "/fin/financial-status/list";
    }

    public finImport() {
        return "/fin/import";
    }

    public finImportHistory() {
        return "/fin/import/history";
    }

    public finSourceImportIblock281() {
        return "/fin/source/import-iblock-281";
    }

    public finLogList() {
        return "/fin/log/list";
    }

    public finLogById({id}: {id: number | string}) {
        return `/fin/log/${id}`;
    }

    public finPartnerWidgetBalances() {
        return "/fin/partner-widget/balances";
    }

    public finPartnerWidgetWriteoffSummary() {
        return "/fin/partner-widget/writeoff-summary";
    }

    public finPartnerWidgetBonusSummary() {
        return "/fin/partner-widget/bonus-summary";
    }

    public finPartnerWidgetPartiallyPaidOrdersCount() {
        return "/fin/partner-widget/partially-paid-orders-count";
    }

    public finPartnerWidgetPartiallyPaidOrdersSummary() {
        return "/fin/partner-widget/partially-paid-orders-summary";
    }

    public finDepositMovementList() {
        return "/fin/deposit-movement/list";
    }

    public finDepositMovementExport(format: 'csv' | 'excel') {
        return `/fin/deposit-movement/export/${format}`;
    }

    public finDepositMovementIncome({id}: {id: number | string}) {
        return `/fin/deposit-movement/income/${id}`;
    }

    public finDepositMovementExpense({id}: {id: number | string}) {
        return `/fin/deposit-movement/expense/${id}`;
    }

    public finPartnerOrderList() {
        return "/fin/partner-order/list";
    }

    public finPartnerOrderExport(format: 'csv' | 'excel') {
        return `/fin/partner-order/export/${format}`;
    }

    public finPartnerOrder({id}: {id: number | string}) {
        return `/fin/partner-order/${id}`;
    }

    public finPartnerOrderSources({id}: {id: number | string}) {
        return `/fin/partner-order/${id}/sources`;
    }

    // done
    public contactFormRoles() {
        return `/partners/contact-form-roles`;
    }

    // *
    public saveNewPartner() {
        return "/partners/save-new";
    }

    public updatePartner() {
        return "/control-panel/partners/update";
    }

    public getPartnersShortInfoForAll() {
        return "/control-panel/partners/get-short-info-for-all";
    }

    public getManagersForPartners() {
        return "/control-panel/users/get-all?selectedRoles=4";
    }

    public getAllManagers() {
        return "/control-panel/users/managers-all";
    }

    public getAllSeniorManagers() {
        return "/control-panel/users/senior-managers-all";
    }

    public getDeleteUser({id}: { id: number }) {
        return `/control-panel/users/delete-user/${id}`;
    }

    public getPartnerStatistics() {
        return "/control-panel/users/statistic";
    }

    public getApplicationsForChangePersonalData() {
        return "/control-panel/applications-for-change-personal-data/get-applications";
    }

    public getApplicationForChangePersonalDataById({applicationId}: { applicationId: number }) {
        return `/control-panel/applications-for-change-personal-data/get-application-by-id/${applicationId}`;
    }

    public getApplicationForChangePersonalMakeDecision() {
        return `/control-panel/applications-for-change-personal-data/make-decision`;
    }

    public applicationForChangePersonalCloseDecision() {
        return `/control-panel/applications-for-change-personal-data/close-decision`;
    }

    public loginUser() {
        return "/auth/login";
    }

    public forgotPassword() {
        return "/auth/forgot-password";
    }

    public loginAsOtherUser() {
        return "/auth/login-as";
    }

    public currentUser() {
        return "/auth/get-current-user";
    }

    // thunk
    public logout() {
        return "/auth/logout";
    }

    public myOrders() {
        return "/my-orders";
    }

    public getOrderSelections() {
        return "/my-orders/order/get-selections";
    }

    public orderedTestTypes() {
        return "/my-orders/get-ordered-test-types";
    }

    // thunk
    public getDNAOrderData({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/get-data`;
    }

    public createChildOrder() {
        return "/orders/create-child-order";
    }

    public softDeleteOrder({orderId}: { orderId: number }) {
        return `/my-orders/order/${orderId}/soft-delete`;
    }

    public setOrderDataConfirmed({orderId}: { orderId: number }) {
        return `/my-orders/order/${orderId}/set-data-confirmed`;
    }

    public getBarcodesForOrder({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/barcode`;
    }

    public allBarcodesPrintedForOrder({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/barcode/all-printed`;
    }

    public orderSheetPrinted({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/sheet-printed`;
    }

    public meetingDidNotTakePlaceForOrder({orderId}: { orderId: number }) {
        return `/my-orders/order/${orderId}/not-take-place`;
    }

    public clientCameButDeclinedStudyForOrder({orderId}: { orderId: number }) {
        return `/my-orders/order/${orderId}/refused`;
    }

    public askForPaperCopies() {
        return `/my-orders/order/delivery-result`;
    }

    public partnerApprovedProvisionalDate({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/agreed`;
    }

    public partnerOffersSlotsToManager() {
        return `/my-orders/order/session-approval/partner`;
    }

    public getSlotsToApproval({orderId}: { orderId: string }) {
        return `/my-orders/order/${orderId}/session-approval`;
    }

    public managerApproveSlot({slotId}: { slotId: number }) {
        return `/my-orders/order/session-approval/${slotId}/manager-approve`;
    }

    public reasonsForManagerToRejectSlots() {
        return "/list/order/session/partner-reject";
    }

    public managerRejectsAllSlots() {
        return `/my-orders/order/session-approval/manager-reject-all-slots`;
    }

    /* TODO убрать дублирование */
    public getMyOrders() {
        return "/my-orders";
    }

    public getParticipantGenders() {
        return "/my-orders/genders";
    }

    public getParticipantDocumentTypes() {
        return "/my-orders/document_types";
    }

    public getAllTestTypes() {
        return "/get-all-test-types";
    }

    public createNewTest() {
        return "/create-new-test";
    }

    public updateTest() {
        return "/update-test";
    }

    public toggleTestInTrash() {
        return "/toggle-test-in-trash";
    }

    public testsInTrash() {
        return "/get-test-in-trash-count";
    }

    public deleteTestsInTrash() {
        return "/delete-tests-in-trash";
    }

    public importTestsFromBitrix() {
        return "/get-tests-from-bitrix";
    }

    // thunk
    public getDownloadFileFromLabForOrder({fileId}: { fileId: string }) {
        return `/download-lab-file-for-order/${fileId}`;
    }

    // thunk
    public getPrintFileFromLabForOrder({fileId}: { fileId: string }) {
        return `/print-lab-file-for-order/${fileId}`;
    }

    // thunk
    public getUploadFileForKnowledgeBaseArticle() {
        return `${this.controlPanel()}/knowledge-base/create-article/upload-file`;
    }

    // thunk
    public getUploadFileForKnowledgeBaseEditArticle() {
        return `${this.controlPanel()}/knowledge-base/edit-article/upload-file`;
    }

    public getUploadArticleContentFile({articleId}: {articleId: string | number}) {
        return `${this.controlPanel()}/knowledge-base/article/${articleId}/content-files`;
    }

    public getDeleteArticleContentFile({articleId, documentId}: {articleId: string | number, documentId: string | number}) {
        return `${this.controlPanel()}/knowledge-base/article/${articleId}/content-files/${documentId}`;
    }

    // thunk
    public getSaveKnowledgeBaseArticle() {
        return `${this.controlPanel()}/knowledge-base/create-article/save`;
    }

    // thunk
    public getSaveKnowledgeBaseEditArticle() {
        return `${this.controlPanel()}/knowledge-base/edit-article/save`;
    }

    // thunk
    //TODO дублирование
    public getKnowledgeBaseGetArticle({articleId}: { articleId: string }) {
        return `${this.controlPanel()}/knowledge-base/edit-article/${articleId}/fetch-article`;
    }

    public getKnowledgeBaseSearchNew() {
        return `/knowledge-base/search`;
    }

    public getAdminKnowledgeBaseSearch() {
        return `${this.controlPanel()}/knowledge-base/search`;
    }

    public learnArticleByParnterEmployee({articleId}: { articleId: string }) {
        return `/knowledge-base/article/${articleId}/user-learnt`;
    }

    // thunk
    public getArticlesOfCategoryInKnowledgeBase({categoryId}: { categoryId: number }) {
        return `${this.controlPanel()}/knowledge-base/get-articles-of-category/${categoryId}`;
    }

    public getPublicKnowledgeBaseArticlesOfCategory({categoryId}: { categoryId: number }) {
        return `/knowledge-base/categories/${categoryId}/articles`;
    }

    // thunk
    public getArticlesInTrashCountInKnowledgeBase() {
        return `${this.controlPanel()}/knowledge-base/get-articles-in-trash-count`;
    }

    // thunk
    public getDeleteArticlesInTrashInKnowledgeBase() {
        return `${this.controlPanel()}/knowledge-base/delete-articles-in-trash`;
    }

    // thunk
    public getKnowledgeBaseArticleData({articleId}: { articleId: string }) {
        return `/knowledge-base/article/${articleId}/get-data`;
    }

    // thunk
    public getKnowledgeBaseArticleChangeInTrash() {
        return `${this.controlPanel()}/knowledge-base/change-article-in-trash`;
    }

    // thunk
    public getKnowledgeBaseCategoriesTree() {
        return `${this.controlPanel()}/knowledge-base/get-categories-tree`;
    }

    public getPublicKnowledgeBaseCategoriesTree() {
        return `/knowledge-base/get-categories-tree`;
    }

    // thunk
    public getKnowledgeBaseSaveNewCategory() {
        return `${this.controlPanel()}/knowledge-base/save-new-category`;
    }

    // thunk
    public getKnowledgeBaseEditCategory() {
        return `${this.controlPanel()}/knowledge-base/edit-category`;
    }

    // thunk
    public getKnowledgeBaseToggleCategoryInTrash() {
        return `${this.controlPanel()}/knowledge-base/toggle-category-in-trash`;
    }

    // thunk
    public getKnowledgeBaseGetCategoriesInTrash() {
        return `${this.controlPanel()}/knowledge-base/get-categories-in-trash-count`;
    }

    // thunk
    public getDeleteCategoriesAndArticlesInTrashInKnowledgeBase() {
        return `${this.controlPanel()}/knowledge-base/delete-categories-and-articles-in-trash`;
    }

    public getUsersRoles() {
        return `${this.controlPanel()}/users/get-all-user-roles`;
    }

    public getSeniorManagers() {
        return `${this.controlPanel()}/users/get-all?selectedRoles=5`;
    }

    public getPartners() {
        return `${this.controlPanel()}/users/get-all?selectedRoles=3`;
    }

    public getSaveUser() {
        return `${this.controlPanel()}/users/save-new-user`;
    }

    public getUpdateUser({id}: { id: number }) {
        return `${this.controlPanel()}/users/update-user/${id}`;
    }

    public getUsers() {
        return `${this.controlPanel()}/users/get-all`;
    }

    public inControlPanelGetUserById({userId}: { userId: number }) {
        return `${this.controlPanel()}/users/get-by-id/${userId}`;
    }

    public getPartnerEmployeesWhoLearntArticle({id}: { id: string }) {
        return `${this.controlPanel()}/users/article-learn/${id}`;
    }

    public getPartnerInfoById({id}: { id: number }) {
        return `/partners/get/${id}`;
    }

    public updatePartnerProfile({id}: { id: number }) {
        return `/partners/${id}/profile`;
    }

    public getManagerByPartnerId({id}: { id: number }) {
        return `/partners/get-manager/${id}`;
    }

    public getPartnersLearning() {
        return `/partners/learning`;
    }

    public confirmPartnerData() {
        return "/auth/access-personal-data";
    }

    public appeals() {
        return "/appeals";
    }

    /** @deprecated */
    public appealsList() {
        return "/appeals/my";
    }

    public appealsTypes() {
        return "/appeals/types";
    }

    public replyToAppeal({id}: { id: number }) {
        return `/appeals/${id}/reply`;
    }

    public callCourierDeprecated() {
        return "/courier/call";
    }

    public flmngr() {
        return "/flmngr";
    }

    public storageImages() {
        return "/storage/images";
    }

    public getAllFamilyLinks() {
        return "/family-links/get-all";
    }

    public getAllSamples() {
        return "/samples/get-all";
    }

    public getAllSamplings() {
        return "/samplings/get-all";
    }

    public documentsCreate() {
        return "/documents/create";
    }

    public documentDelete() {
        return "/documents/delete";
    }

    public orderLegalStatus() {
        return "/list/order-legal-status";
    }

    public orderAdditionalServices() {
        return "/list/order-additional-service";
    }

    public researchSigns() {
        return "/list/research-signs";
    }

    public orderTerms() {
        return "/list/order-terms";
    }

    public partnerTypes() {
        return "/list/partner-type";
    }

    public pregnancyPeculiarities() {
        return "/list/pregnancy";
    }

    public priceListServices() {
        return "/list/order-service";
    }

    public billStatusesList() {
        return "/list/bill_status";
    }

    public orderStatusesList() {
        return "/list/order_status";
    }

    public createParticipantForOrder() {
        return "/order/participant/create";
    }

    public deleteParticipantFromOrder() {
        return "/order/participant/delete";
    }

    public updateParticipantForOrder() {
        return "/order/participant/update";
    }

    public shortInfoForOrders() {
        return "/order/statistic";
    }

    public createSlide() {
        return "/slider/create";
    }

    public slidesForAll() {
        return "/slider";
    }

    public slidesForAdmin() {
        return "/slider/admin";
    }

    public deleteSlide({id}: { id: number }) {
        return `/slider/${id}`;
    }

    public getSlideById({id}: { id: number }) {
        return `/slider/get/${id}`;
    }

    public updateSlide() {
        return `/slider/update`;
    }

    public appeals2TicketSubjectList() {
        return "/ticket/subject/list";
    }

    public appeals2TicketTypes() {
        return "/ticket/subject";
    }

    public ticketStatus() {
        return "/ticket/status";
    }

    public appeals2StatusesList() {
        return "/ticket/status/list";
    }

    public appeals2Urgency() {
        return "/ticket/urgent";
    }

    public appeals2UrgencyList() {
        return "/ticket/urgent/list";
    }

    public appeals2CreateTicket() {
        return "/ticket";
    }

    public appeals2TicketCreationLimit() {
        return "/control-panel/ticket/creation-limit";
    }

    public appeals2ActiveTopicsTree() {
        return "/control-panel/ticket/topic/active-tree";
    }

    public appeals2VisibleTopicsTree() {
        return "/control-panel/ticket/topic/visible-tree";
    }

    public appeals2AttachSubtopic() {
        return "/control-panel/ticket/topic/attach-subtopic";
    }

    public appeals2TicketTopicsListWithoutNotifications() {
        return "/control-panel/ticket/topic/list-without-notifications";
    }


    public appeals2List() {
        return "/ticket/list";
    }

    public appeals2TicketsForOrderByOrderId({id}: { id: number }) {
        return `/ticket/order/${id}`;
    }

    public appeals2ViewTicket({number}: { number: string }) {
        return `/ticket/${number}`;
    }

    public appeals2Reply({id}: { id: number }) {
        return `/ticket/${id}/reply`;
    }

    public ticketMessageParse({id}: {id: number}) {
        return `/control-panel/ticket/message-parse/${id}`;
    }

    public ticketMessageParseUpdate() {
        return "/control-panel/ticket/message-parse";
    }

    public appeals2Clarify({id}: { id: number }) {
        return `/ticket/${id}/clarify`;
    }

    public appeals2Extra1Hour({id}: { id: number }) {
        return `/ticket/${id}/1-hour`;
    }

    public appeals2Extra4Hour({id}: { id: number }) {
        return `/ticket/${id}/4-hour`;
    }

    public appeals2Extra8Hour({id}: { id: number }) {
        return `/ticket/${id}/8-hour`;
    }

    public ticketRenewalTimesActiveList() {
        return "/control-panel/ticket/renewal-time/active-list";
    }

    public appeals2RequestExtraTime({id}: {id: number}) {
        return `/control-panel/ticket/${id}/request-extra-time`;
    }

    public appeals2Update({id}: { id: number }) {
        return `/ticket/${id}/update`;
    }

    public appeals2RequestClose({id}: {id: number}) {
        return `/control-panel/ticket/${id}/request-close`;
    }

    public appeals2TopicHistory({id}: { id: number }) {
        return `/control-panel/ticket/${id}/topic-history`;
    }

    public ticketAuditList() {
        return `/control-panel/ticket/audit/list`;
    }

    public ticketEventList() {
        return `/control-panel/ticket/event/list`;
    }

    public privateTicketTags({ticketId}: {ticketId: number}) {
        return `/control-panel/ticket/${ticketId}/private-tags`;
    }

    public privateTicketTagsSearch() {
        return `/control-panel/ticket/private-tags/search`;
    }

    public privateTicketTag({ticketId, tagId}: {ticketId: number; tagId: number}) {
        return `/control-panel/ticket/${ticketId}/private-tags/${tagId}`;
    }

    public appeals2SetViewedMessage() {
        return `/ticket/message/set-viewed`;
    }

    public appeals2SetUnreadByTicket({id}: { id: number }) {
        return `/control-panel/ticket/${id}/set-unread`;
    }

    public appeals2MessageTemplate() {
        return `/ticket/message-template/list`;
    }

    public appealsTemplatesManagement() {
        return `/control-panel/ticket/message-template`;
    }

    public appealsTemplatesManagementList() {
        return `${this.appealsTemplatesManagement()}/list`;
    }

    public appealsTemplatesByTopic() {
        return `${this.appealsTemplatesManagement()}/by-topic`;
    }

    public appealsTemplatesCommon() {
        return `${this.appealsTemplatesManagement()}/common`;
    }

    public appealsTemplatesFromTicket() {
        return `${this.appealsTemplatesManagement()}/from-ticket`;
    }

    public createNewPushSubscription() {
        return "/webpush/subscribe";
    }

    public unsubscibeFromPushSubscription() {
        return "/webpush/unsubscribe";
    }

    public notifications() {
        return "/notifications";
    }

    public notificationsSetViewed({id}: { id: number }) {
        return `/notifications/${id}/viewed`;
    }

    public ticketReaction() {
        return "/ticket/reaction";
    }

    public ticketReactionList() {
        return "/ticket/reaction/list";
    }

    public labWorkingHours() {
        return "/control-panel/lab/work-time";
    }

    public staffWorkingHours() {
        return "/control-panel/users/work-time";
    }

    public getPhoneSubjects() {
        return `${this.controlPanel()}/phone/subjects`;
    }

    public getCountriesList() {
        return `${this.controlPanel()}/geo/country/list`;
    }

    public referenceBookCountry() {
        return `${this.controlPanel()}/geo/country`;
    }

    public getCitiesList() {
        return `${this.controlPanel()}/geo/city/list`;
    }

    public referenceBookCity() {
        return `${this.controlPanel()}/geo/city`;
    }

    public controlPanelPhone() {
        return `${this.controlPanel()}/phone`;
    }

    public controlPanelAddress() {
        return `${this.controlPanel()}/address`;
    }

    public statisticsOfRecordingsToPartners() {
        return "/control-panel/report/approved";
    }

    public statisticsOfTickets() {
        return "/control-panel/report/tickets";
    }

    public ticketMessageParseStats() {
        return "/control-panel/ticket/message-parse/stats";
    }

    public ticketMessageParseStatsUsers() {
        return "/control-panel/ticket/message-parse/stats/users";
    }

    public ticketMessageParseStatsRoles() {
        return "/control-panel/ticket/message-parse/stats/roles";
    }

    public ticketPartnerRating() {
        return "/control-panel/ticket/partner-rating";
    }

    public ticketPartnerRatings() {
        return "/control-panel/ticket/partner-ratings";
    }

    public statisticsOfManagersResponses() {
        return "/manager-response-stats";
    }

    public countriesLegalForms() {
        return "/control-panel/legal/entity-setting/olf/list"
    }

    public statisticsOfManagersResponsesExcelExport() {
        return "/manager-response-stats/export";
    }

    public legalFormsByCountryId() {
        return "/control-panel/legal/olf/list"
    }

    public createLegalFormForCountry() {
        return "/control-panel/legal/olf"
    }

    public deleteCountryOLF() {
        return "/control-panel/legal/olf"
    }

    public updateCountryOLF() {
        return "/control-panel/legal/olf"
    }

    public countriesWithRequisites() {
        return "/control-panel/legal/entity-setting/requisite/list"
    }

    public requisitesByCountryId() {
        return "/control-panel/legal/requisite/list"
    }

    public createRequisiteForCountry() {
        return "/control-panel/legal/requisite"
    }

    public updateCountryRequisite() {
        return "/control-panel/legal/requisite"
    }

    public deleteCountryRequisite() {
        return "/control-panel/legal/requisite"
    }

    public OLFToRequisiteRules() {
        return "/control-panel/legal/requisite-rule/list"
    }

    public createOLFToRequisiteRule() {
        return "/control-panel/legal/requisite-rule"
    }

    public updateOLFToRequisiteRule() {
        return "/control-panel/legal/requisite-rule"
    }

    public deleteOLFToRequisiteRule() {
        return "/control-panel/legal/requisite-rule"
    }

    public documentTypesList() {
        return "/control-panel/documents/type/list";
    }

    //TODO дублирование
    public documentType() {
        return "/control-panel/documents/type";
    }

    public laboratoryLegalEntitiesList() {
        return "/control-panel/laboratory/list";
    }

    public laboratoryLegalEntities() {
        return "/control-panel/laboratory";
    }

    public documentStatusList() {
        return "/control-panel/partner/document/status/list";
    }

    public documentStatus() {
        return "/control-panel/partner/document/status";
    }

    public errorList() {
        return "/control-panel/errors/list";
    }

    public error() {
        return "/control-panel/errors";
    }

    public saveNewManagerForPartners() {
        return "/control-panel/partner/change-manager";
    }

    public managerTransferList() {
        return "/control-panel/transfer-partners/list";
    }

    public managerTransfer() {
        return "/control-panel/transfer-partners";
    }

    public managerTransferBack() {
        return "/control-panel/transfer-partners/back";
    }

    public familyStepsList() {
        return "/control-panel/research-flag/family-steps/list";
    }

    public familySteps() {
        return "/control-panel/research-flag/family-steps";
    }

    public familyStepsListActive() {
        return "/list/family-steps";
    }

    public attributeSelectionRulesList() {
        return "/control-panel/research-flag/attribute-selection-rule/list";
    }

    public attributeSelectionRules() {
        return "/control-panel/research-flag/attribute-selection-rule";
    }

    public attributeSelectionRulesListActive() {
        return "/list/attribute-selection-rule";
    }

    public pedigreesList() {
        return "/control-panel/research-flag/pedigree/list";
    }

    public pedigrees() {
        return "/control-panel/research-flag/pedigree";
    }

    public pedigreesListActive() {
        return "/list/pedigrees";
    }

    public attributeRuleForNParticipantsList() {
        return "/control-panel/orders/family-link/network/list";
    }

    public attributeRuleForNParticipants() {
        return "/control-panel/orders/family-link/network";
    }

    public laboratoryQuestionsStatusesList() {
        return "/control-panel/question/status/list";
    }

    public laboratoryQuestionsStatus() {
        return "/control-panel/question/status";
    }

    public templateQuestionsList() {
        return "/list/question-templates";
    }

    public labQuestionsForPartners() {
        return "/list/order-question";
    }

    public rulesList() {
        return "/control-panel/rule/list";
    }

    public rule() {
        return "/control-panel/rule";
    }

    public answerRuleDictionaryList() {
        return "/list/answer-rule-dictionary";
    }

    public answerRuleDictionaryByValueList() {
        return "/list/answer-rule-dictionary-by-value";
    }

    public answerRuleProcessesList() {
        return "/list/answer-rule-processes";
    }

    public orderQuestionsList() {
        return "/list/order-question-list";
    }

    public orderQuestionsSave() {
        return "/control-panel/question/answer";
    }

    public laboratoryRulesList() {
        return "/control-panel/rule/list-question";
    }

    public laboratoryRules() {
        return "/control-panel/rule/question";
    }

    public fileExtensionsList() {
        return "/control-panel/file/extension/list";
    }

    public fileExtensions() {
        return "/control-panel/file/extension";
    }

    public fileExtensionsActiveList() {
        return "/list/file-extensions";
    }

    public fileMeaningList() {
        return "/control-panel/question/file/list"
    }

    public fileMeaning() {
        return "/control-panel/question/file"
    }

    public fileMeaningActiveList() {
        return "/list/question-files"
    }

    public fileMeaningsToExtensionsList() {
        return "/control-panel/question/file-extension/list"
    }

    public fileMeaningsToExtensions() {
        return "/control-panel/question/file-extension"
    }

    public getLoginAsLinkById(id: number) {
        return `/control-panel/user/link/${id}`;
    }

    public loginAsLink() {
        return "/control-panel/user/link";
    }

    public rolesList() {
        return "/control-panel/role/list";
    }

    public roles() {
        return "/control-panel/role";
    }

    public sectionsList() {
        return "/control-panel/permissions/section/parent-list";
    }

    public blocksList() {
        return "/control-panel/permissions/section/child-list";
    }

    public sections() {
        return "/control-panel/permissions/section";
    }

    public permissionsSectionsList() {
        return "/control-panel/permissions/sections";
    }

    public permissionsList() {
        return "/control-panel/permissions/list";
    }

    public permissionsSave() {
        return "/control-panel/permissions/save";
    }

    public permissionsRemove() {
        return "/control-panel/permissions/remove";
    }

    public myPermissions() {
        return "/control-panel/permissions/user-permissions";
    }

    public menuList() {
        return "/control-panel/menu/list";
    }

    public menu() {
        return "/control-panel/menu";
    }

    public currentUserMenu() {
        return "/control-panel/menu/user-menu";
    }

    public confirmVisit() {
        return "/orders/set-visited";
    }

    public cancelCourier() {
        return "/orders/cancel-courier";
    }

    public handOverToCourier() {
        return "/orders/transfer-to-courier";
    }

    public addTrackNumber() {
        return "/orders/add-track-number";
    }

    public callCourier() {
        return "/orders/call-courier";
    }

    public confirmKinshipSchema() {
        return "/orders/confirm-kinship-schema";
    }

    public orderIrrelevanceReasonsList() {
        return "/list/order-irrelevance-reasons";
    }

    public markOrderAsNotActual() {
        return "/orders/mark-as-not-actual";
    }

    public informNonstandard({orderId}: { orderId: number }) {
        return `/order/inform-nonstandard/${orderId}`;
    }

    public getOrderAdditionalServices() {
        return "/order/additional-services";
    }

    public createAdditionalServiceOrder() {
        return "/order/create-additional-service-deal";
    }

    public declineAdditionalServiceOrder() {
        return "/order/refuse-additional-service-deal";
    }

    public allowCustomService() {
        return "/order/forward-nonstd-additional-service";
    }

    public requestCustomService() {
        return "/order/request-nonstd-additional-service";
    }

    public setAdditionalServicePaid() {
        return "/order/set-additional-service-paid";
    }

    public setAdditionalServiceUnpaid() {
        return "/order/set-additional-service-unpaid";
    }

    public approveCustomService() {
        return "/order/approve-nonstd-additional-service";
    }

    public approveCustomServicePrice() {
        return "/order/approve-nonstd-additional-service-price";
    }

    public rejectCustomService() {
        return "/order/reject-nonstd-additional-service";
    }

    public declineCustomService() {
        return "/order/reject-nonstd-additional-service-request";
    }

    public cancelCustomService() {
        return "/order/refuse-additional-service-deal";
    }

    public countWaitingVisitDate() {
        return "/orders/count-waiting-visit-date";
    }

    public referenceBookRulesOrderLegalStatusList() {
        return "/control-panel/orders/order-legal-status/list";
    }

    public referenceBookRulesOrderLegalStatus() {
        return "/control-panel/orders/order-legal-status";
    }

    public referenceBookRulesAnalysisList() {
        return "/control-panel/orders/analysis/list";
    }

    public referenceBookRulesAnalysis() {
        return "/control-panel/orders/analysis";
    }

    public referenceBookRulesFamilyLinkList() {
        return "/control-panel/orders/family-link-list/list";
    }

    public referenceBookRulesFamilyLink() {
        return "/control-panel/orders/family-link-list";
    }

    public referenceBookRulesOrderTermList() {
        return "/control-panel/orders/order-term/list";
    }

    public referenceBookRulesOrderTerm() {
        return "/control-panel/orders/order-term";
    }

    public referenceBookRulesResearchSignList() {
        return "/control-panel/orders/research-sign/list";
    }

    public referenceBookRulesResearchSign() {
        return "/control-panel/orders/research-sign";
    }

    public referenceBookRulesSampleList() {
        return "/control-panel/orders/sample/list";
    }

    public referenceBookRulesSample() {
        return "/control-panel/orders/sample";
    }

    public nonstandardConsentFileList() {
        return "/v2/control-panel/orders/nonstandard-consent-file/list";
    }

    public nonstandardConsentFileCurrent() {
        return "/v2/control-panel/orders/nonstandard-consent-file/current";
    }

    public nonstandardConsentFileArchive() {
        return "/v2/control-panel/orders/nonstandard-consent-file/archive";
    }

    public nonstandardConsentFileReplace() {
        return "/v2/control-panel/orders/nonstandard-consent-file";
    }

    public nonstandardConsentFileDownload() {
        return "/v2/control-panel/orders/nonstandard-consent-file/download";
    }

    public nonstandardConsentFileArchiveDownload(id: number) {
        return `/v2/control-panel/orders/nonstandard-consent-file/archive/${id}/download`;
    }

    public nonstandardConsentFileDelete() {
        return "/v2/control-panel/orders/nonstandard-consent-file";
    }

    public referenceBookRulesSamplingList() {
        return "/control-panel/orders/sampling/list";
    }

    public referenceBookRulesSampling() {
        return "/control-panel/orders/sampling";
    }

    public referenceBookRulesAdditionalServiceList() {
        return "/control-panel/orders/additional-service/list";
    }

    public referenceBookRulesAdditionalService() {
        return "/control-panel/orders/additional-service";
    }

    public hintsList() {
        return "/control-panel/hints/list";
    }

    public hintsLocationsList() {
        return "/control-panel/hints/locations/list";
    }

    public hints() {
        return "/control-panel/hints";
    }

    public referenceBookRulesGenderList() {
        return "/control-panel/orders/gender/list";
    }

    public hintByAlias(alias: string) {
        return `/hint/${alias}`;
    }

    public referenceBookRulesGender() {
        return "/control-panel/orders/gender";
    }

    public referenceBookRulesTicketTopicsList() {
        return "/control-panel/ticket/topic/list";
    }

    public referenceBookRulesTicketTopicsRoots() {
        return "/control-panel/ticket/topic/roots";
    }

    public referenceBookRulesTicketTopicsChildren(parentId: number | string) {
        return `/control-panel/ticket/topic/${parentId}/children`;
    }

    public referenceBookRulesTicketTopicsAvailableParents() {
        return "/control-panel/ticket/topic/available-parents";
    }

    public referenceBookRulesTicketTopics() {
        return "/control-panel/ticket/topic";
    }

    public referenceBookRulesTicketTopic(id: number | string) {
        return `/control-panel/ticket/topic/${id}`;
    }

    public referenceBookRulesTicketTransferReasonsList() {
        return "/control-panel/ticket/transfer-reason/list";
    }

    public referenceBookRulesTicketTransferReasons() {
        return "/control-panel/ticket/transfer-reason";
    }

    public referenceBookRulesTicketResponseStatusesList() {
        return "/control-panel/ticket/response-status/list";
    }

    public referenceBookRulesTicketResponseStatuses() {
        return "/control-panel/ticket/response-status";
    }

    public referenceBookRulesIdentityDocList() {
        return "/control-panel/orders/order-identity-doc/list";
    }

    public referenceBookRulesIdentityDoc() {
        return "/control-panel/orders/order-identity-doc";
    }

    public changeJournalTypeList() {
        return "/control-panel/change-journal/type/list";
    }

    public partnerProductsList() {
        return "/bitrix/partner-products";
    }

    public getPartnersByManagerId() {
        return "/control-panel/ticket/partners";
    }

    public getMassPartners() {
        return "/control-panel/ticket/mass-partners";
    }

    public getTicketTypes() {
        return "/control-panel/ticket/type/list-no-main";
    }

    public changeStatus() {
        return "/orders/change-status";
    }

    public createMassTickets() {
        return "/control-panel/ticket/mass";
    }

    public getAllOrderStatuses() {
        return "/orders/statuses";
    }

    public changeableFieldsList() {
        return "/list/changeable-fields";
    }

    public ticketTemplatesList() {
        return "/control-panel/ticket/list";
    }

    public ticketTemplates() {
        return "/control-panel/ticket";
    }

    public unreadPartnersList() {
        return "/control-panel/ticket/unread-partner";
    }

    public clientProductsList() {
        return "/bitrix/client-products";
    }

    public productFilterData() {
        return "/bitrix/product-filter-data";
    }

    public calculateSelections() {
        return "/order/calculate/selections";
    }

    public calculatePriceTotal() {
        return "/order/calculate/price-total";
    }

    public calculatePriceSample() {
        return "/order/calculate/price-sample";
    }

    public priceCalculationAnalysisRulesList() {
        return "/control-panel/orders/calculate/analyse/list";
    }

    public priceCalculationAnalysisRule() {
        return "/control-panel/orders/calculate/analyse";
    }

    public priceCalculationAdditionalServicesList() {
        return "/control-panel/orders/calculate/additional-service/list";
    }

    public priceCalculationAdditionalServices() {
        return "/control-panel/orders/calculate/additional-service";
    }

    public priceCalculationParticipantLimitsList() {
        return "/control-panel/orders/calculate/analyse-limit/list";
    }

    public priceCalculationParticipantLimits() {
        return "/control-panel/orders/calculate/analyse-limit";
    }

    public priceCalculationSamplesList() {
        return "/control-panel/orders/calculate/sample/list";
    }

    public priceCalculationSamples() {
        return "/control-panel/orders/calculate/sample";
    }

    public priceCalculationParticipantsList() {
        return "/control-panel/orders/calculate/participant/list";
    }

    public priceCalculationParticipants() {
        return "/control-panel/orders/calculate/participant";
    }

    public lkNotificationList() {
        return "/control-panel/lk/notification/list";
    }

    public lkNotification() {
        return "/control-panel/lk/notification";
    }

    public lkNotificationFilters() {
        return "/control-panel/lk/notification/filters";
    }

    public changeApprovalList() {
        return "/control-panel/change-approval/list";
    }

    public acceptApprovalChange() {
        return "/control-panel/change-approval/accept";
    }

    public rejectApprovalChange() {
        return "/control-panel/change-approval/reject";
    }

    public revokeApprovalChange() {
        return "/control-panel/change-approval/revoke";
    }

    public changeApprovalSyncList() {
        return "/control-panel/change-approval/sync-list";
    }

    public syncListAccept() {
        return "/control-panel/change-approval/accept-sync";
    }

    public syncListReject() {
        return "/control-panel/change-approval/reject-sync";
    }

    public changeApprovalDictionaries() {
        return "/control-panel/change-approval/dictionaries";
    }

    public changeApprovalTypes() {
        return "/control-panel/change-approval/types";
    }

    public changeApprovalApprovalStatusList() {
        return "/control-panel/change-approval/approval-status-list";
    }

    public changeApprovalUserStatusList() {
        return "/control-panel/change-approval/user-status-list";
    }

    public changeApprovalSyncStatusList() {
        return "/control-panel/change-approval/sync-status-list";
    }

    public b24SyncRulesList() {
        return "/control-panel/rule/b24-sync";
    }

    public b24SyncRule() {
        return "/control-panel/rule/b24-sync";
    }

    public b24SyncRulesMutate() {
        return "/control-panel/rule";
    }

    public b24SyncRuleFields() {
        return "/control-panel/rule/fields";
    }

    public tableFieldsList() {
        return "/control-panel/orders/sync/table-fields/list";
    }

    public tableFields() {
        return "/control-panel/orders/sync/table-fields";
    }

    public syncBitrixFieldsList() {
        return "/control-panel/orders/sync/bitrix-fields/list";
    }

    public syncBitrixFields() {
        return "/control-panel/orders/sync/bitrix-fields";
    }

    public syncGroupFieldsList() {
        return "/control-panel/orders/sync/group-fields/list";
    }

    public syncGroupFields() {
        return "/control-panel/orders/sync/group-fields";
    }

    public syncGroupsList() {
        return "/control-panel/orders/sync/groups/list";
    }

    public syncGroups() {
        return "/control-panel/orders/sync/groups";
    }

    public buttonReferencesList() {
        return "/control-panel/button-references/list";
    }

    public buttonReferencesMutate() {
        return "/control-panel/button-references";
    }

    public checksumErrorsList() {
        return "/control-panel/orders/sync/checksum-errors/list";
    }

    public checksumError() {
        return "/control-panel/orders/sync/checksum-errors";
    }

    public orderHistory(id: number | string) {
        return `/order/history/${id}`;
    }

    public bitrixFields() {
        return `/bitrix/fields`;
    }

    public bitrixFieldsList() {
        return `/bitrix/fields`;
    }

    public controlPanelBitrixFields() {
        return `/control-panel/bitrix/fields`;
    }

    public bitrixStages() {
        return `/bitrix/stages`;
    }

    public bitrixStageList() {
        return `/control-panel/bitrix/stage/list`;
    }

    public bitrixStageResource() {
        return `/control-panel/bitrix/stage`;
    }

    public b24Tasks() {
        return `/control-panel/function-desc/b24-task`;
    }

    public b24TasksList() {
        return `/control-panel/function-desc/b24-task/list`;
    }

    public b24Stages() {
        return `/control-panel/function-desc/b24-stage`;
    }

    public b24StagesList() {
        return `/control-panel/function-desc/b24-stage/list`;
    }

    public b24CategorySmartList() {
        return `/control-panel/function-desc/b24-category/smart/list`;
    }

    public b24CategoryFunnelList() {
        return `/control-panel/function-desc/b24-category/funnel/list`;
    }

    public b24Category() {
        return `/control-panel/function-desc/b24-category`;
    }

    public b24FieldList() {
        return `/control-panel/function-desc/b24-field/list`;
    }

    public b24Field() {
        return `/control-panel/function-desc/b24-field`;
    }

    public b24BusinessProcessList() {
        return `/control-panel/function-desc/business-process/list`;
    }

    public b24BusinessProcess() {
        return `/control-panel/function-desc/business-process`;
    }

    public lisEntityList() {
        return `/control-panel/function-desc/lis-entity/list`;
    }

    public lisEntity() {
        return `/control-panel/function-desc/lis-entity`;
    }

    public entity1CList() {
        return `/control-panel/function-desc/entity-1c/list`;
    }

    public entity1C() {
        return `/control-panel/function-desc/entity-1c`;
    }

    public functionDescTagList() {
        return `/control-panel/function-desc/tag/list`;
    }

    public functionDescTag() {
        return `/control-panel/function-desc/tag`;
    }

    public servicePositionList() {
        return `/control-panel/function-desc/service-position/list`;
    }

    public servicePosition() {
        return `/control-panel/function-desc/service-position`;
    }

    public fdListList() {
        return `/control-panel/function-desc/fd-list/list`;
    }

    public fdList() {
        return `/control-panel/function-desc/fd-list`;
    }

    public b24CompanyServiceList() {
        return `/control-panel/function-desc/b24-company-service/list`;
    }

    public b24CompanyService() {
        return `/control-panel/function-desc/b24-company-service`;
    }

    public b24CompanyPositionList() {
        return `/control-panel/function-desc/b24-company-position/list`;
    }

    public b24CompanyPosition() {
        return `/control-panel/function-desc/b24-company-position`;
    }

    public b24EntityList() {
        return `/control-panel/function-desc/b24-entity/list`;
    }

    public b24Entity() {
        return `/control-panel/function-desc/b24-entity`;
    }

    public functionDescriptionList() {
        return `/control-panel/function-desc/fd-table/list`;
    }

    public functionDescription() {
        return `/control-panel/function-desc/fd-table`;
    }

    public orderStatusesWithNoteList() {
        return "/control-panel/orders/order-status/list";
    }

    public orderStatus() {
        return "/control-panel/orders/order-status";
    }

    public testingReferenceBookList(resource: string) {
        return `/testing/${resource}/list`;
    }

    public testingReferenceBookActiveList(resource: string) {
        return `/testing/${resource}/active-list`;
    }

    public testingReferenceBook(resource: string) {
        return `/testing/${resource}`;
    }

    public testingTopicList() {
        return "/testing/topic/list";
    }

    public testingTopic() {
        return "/testing/topic";
    }

    public testingTopicById(id: number | string) {
        return `/testing/topic/${id}`;
    }

    /**
     * @deprecated Backend endpoint удалён коммитом da24d759f от 16.10.2026.
     */
    public testingTopicAvailableTopics() {
        return "/testing/topic/available-topics";
    }

    /**
     * @deprecated Backend endpoint удалён коммитом da24d759f от 16.10.2026.
     */
    public testingTopicRelation() {
        return "/testing/topic/relation";
    }

    public testingDocumentList() {
        return "/testing/document/list";
    }

    public testingDocument() {
        return "/testing/document";
    }

    public testingDocumentById(id: number | string) {
        return `/testing/document/${id}`;
    }

    public testingDocumentMaterials(id: number | string) {
        return `/testing/document/${id}/materials`;
    }

    public testingMaterialList() {
        return "/testing/material/list";
    }

    public testingMaterial() {
        return "/testing/material";
    }

    public testingMaterialById(id: number | string) {
        return `/testing/material/${id}`;
    }

    public testingKnowledgeBaseTopics() {
        return "/testing/knowledge-base/topics";
    }

    public testingKnowledgeBaseMaterials() {
        return "/testing/knowledge-base/materials";
    }

    public testingKnowledgeBaseMaterialByAlias(alias: string) {
        return `/testing/knowledge-base/materials/${alias}`;
    }

    public testingKnowledgeBaseDocumentDownload(alias: string) {
        return `/testing/knowledge-base/documents/${alias}/download`;
    }

    public testingRecentlyOpened() {
        return "/testing/recently-opened";
    }

    public testingMyResultsTests() {
        return "/testing/my-results/tests";
    }

    public testingMyResultsMaterials() {
        return "/testing/my-results/materials";
    }

    public testingMyResult(id: number | string) {
        return `/testing/my-results/${id}`;
    }

    public testingMyResultTestStart() {
        return "/testing/my-results/test/start";
    }

    public testingMyResultMaterialStart() {
        return "/testing/my-results/material/start";
    }

    public testingMyResultAnswers(id: number | string) {
        return `/testing/my-results/${id}/answers`;
    }

    public testingMyResultComplete(id: number | string) {
        return `/testing/my-results/${id}/complete`;
    }

    public testingMyResultConfirm(id: number | string) {
        return `/testing/my-results/${id}/confirm`;
    }

    public testingMaterialsQuestionsMaterials() {
        return "/testing/materials-questions/materials";
    }

    public testingMaterialsQuestionsQuestions() {
        return "/testing/materials-questions/questions";
    }

    public testingMaterialsQuestionsQuestion(alias: string) {
        return `/testing/materials-questions/questions/${encodeURIComponent(alias)}`;
    }

    public testingMyQuestionAnswer(alias: string) {
        return `/testing/my-question-answers/${encodeURIComponent(alias)}`;
    }

    public testingMaterialsQuestionsAssignments() {
        return "/testing/materials-questions/my-assignments";
    }

    public testingMaterialsQuestionsTags() {
        return "/testing/materials-questions/tags";
    }

    public testingMaterialsQuestionsTests() {
        return "/testing/materials-questions/tests";
    }

    public testingOverview() {
        return "/testing/overview";
    }

    public testingOverviewTasks() {
        return "/testing/overview/tasks";
    }

    public testingOverviewTaskComplete(id: number | string) {
        return `/testing/overview/tasks/${id}/complete`;
    }

    public testingMaterialTagsSearch() {
        return "/testing/material-tags/search";
    }

    public testingTags() {
        return "/testing/tags";
    }

    public testingTag(id: number | string) {
        return `/testing/tags/${id}`;
    }

    public testingTagRelations(id: number | string) {
        return `/testing/tags/${id}/relations`;
    }

    public testingHowItWorksMaterial() {
        return "/testing/material/how-it-works";
    }

    public testingMaterialAudit(id: number | string) {
        return `/testing/material/${id}/audit`;
    }

    public testingQuestionList() {
        return "/testing/question/list";
    }

    public testingQuestion() {
        return "/testing/question";
    }

    public testingQuestionById(id: number | string) {
        return `/testing/question/${id}`;
    }

    public testingQuestionActivate(id: number | string) {
        return `/testing/question/${id}/activate`;
    }

    public testingQuestionTagsSearch() {
        return "/testing/question-tags/search";
    }

    public testingQuestionTags(id: number | string) {
        return `/testing/question/${id}/tags`;
    }

    public testingTestList() {
        return "/testing/test/list";
    }

    public testingTest() {
        return "/testing/test";
    }

    public testingTestById(id: number | string) {
        return `/testing/test/${id}`;
    }

    public testingTestActivate(id: number | string) {
        return `/testing/test/${id}/activate`;
    }

    public testingTestQuestionsSearch() {
        return "/testing/test-questions/search";
    }

    public testingAssignmentList() {
        return "/testing/assignment/list";
    }

    public testingAssignment() {
        return "/testing/assignment";
    }

    public testingAssignmentById(id: number | string) {
        return `/testing/assignment/${id}`;
    }

    public testingAssignmentActivate(id: number | string) {
        return `/testing/assignment/${id}/activate`;
    }

    public testingAssignmentTestsSearch() {
        return "/testing/assignment-tests/search";
    }

    public testingAssignmentMaterialsSearch() {
        return "/testing/assignment-materials/search";
    }

    public testingAssignmentQuestionsSearch() {
        return "/testing/assignment-questions/search";
    }

    public testingAssignmentManagersSearch() {
        return "/testing/assignment-managers/search";
    }

    public testingProgressResultsAssignments() {
        return "/testing/progress-results/assignments";
    }

    public testingProgressResultsUsers() {
        return "/testing/progress-results/users";
    }

    public testingProgressResultsUserObjects(userId: number | string) {
        return `/testing/progress-results/users/${userId}`;
    }

    public testingProgressResultsUserAttempts(userId: number | string) {
        return `/testing/progress-results/users/${userId}/attempts`;
    }

    public testingProgressResultsTopicsSearch() {
        return "/testing/progress-results/search/topics";
    }

    public testingProgressResultsTestsSearch() {
        return "/testing/progress-results/search/tests";
    }

    public testingProgressResultsMaterialsSearch() {
        return "/testing/progress-results/search/materials";
    }

    public testingProgressResultsManagersSearch() {
        return "/testing/progress-results/search/managers";
    }

    public permissionSectionsDescriptionList() {
        return "/control-panel/permissions/section/list";
    }

    public permissionSectionDescription() {
        return "/control-panel/permissions/section/description";
    }

    public permissionSectionActionsDescriptionList() {
        return "/control-panel/permissions/section-action/list";
    }

    public permissionSectionActionDescription() {
        return "/control-panel/permissions/section-action";
    }

    public partnersListV2() {
        return "/partners/list";
    }

    public loginAsPartnerSwitch() {
        return "/partners/login-as/switch-to-user";
    }

    public loginAsPartnerRevert() {
        return "/partners/login-as/revert-switch";
    }

    public describeKinshipSurveyList() {
        return "/control-panel/orders/family-link/question/list";
    }

    public describeKinshipSurvey() {
        return "/control-panel/orders/family-link/question";
    }

    public describeKinshipSurveyActiveList() {
        return "/list/order-family-question";
    }

    public courierRequestsList() {
        return "/courier-requests/requests";
    }

    public courierRequestsTrackNumbersLastMonth() {
        return "/courier-requests/track-numbers-last-month";
    }

    public visitWithDetermination() {
        return "/orders/visit-with-determination";
    }

    public courtRevoke() {
        return "/orders/court-revoke";
    }

    public courtNoShow() {
        return "/orders/court-no-show";
    }

    public inControlPanelGetUserCities() {
        return `${this.controlPanel()}/user/cities`;
    }

    public notificationRuleList() {
        return "/control-panel/notification/rule/list";
    }

    public notificationRule() {
        return "/control-panel/notification/rule";
    }

    public notificationLogsList() {
        return "/control-panel/notification/logs/list";
    }

    public notificationLogs() {
        return "/control-panel/notification/logs";
    }

    public notificationTypes() {
        return "/control-panel/notification/types";
    }

    public notificationConditions() {
        return "/control-panel/notification/conditions";
    }

    public notificationRecipients() {
        return "/control-panel/notification/recipients";
    }

    public notificationRoles() {
        return "/control-panel/notification/roles";
    }

    public notificationUsers() {
        return "/control-panel/notification/users";
    }

    public orderResultFileIssues() {
        return "/control-panel/orders/result-file-issues";
    }

    public orderB24StatusMismatches() {
        return "/control-panel/orders/b24-status-mismatches";
    }

    public orderResultFileIssueImportDocuments(orderId: number | string) {
        return `/control-panel/orders/result-file-issues/${orderId}/import-documents`;
    }

    public ticketSuperStatusList() {
        return "/control-panel/ticket/super-status/list";
    }

    public ticketTagList() {
        return "/control-panel/ticket/tag/list";
    }

    public partnerTags() {
        return "/partners/tags";
    }

    public partnerTagsByPartner(partnerId: number) {
        return `/partners/${partnerId}/tags`;
    }

    public partnerTagByPartner(partnerId: number, tagId: number) {
        return `/partners/${partnerId}/tags/${tagId}`;
    }

    public partnerFieldsList() {
        return "/control-panel/partner/fields/list";
    }

    public partnerFields() {
        return "/control-panel/partner/fields";
    }

    public partnerFieldsActive() {
        return "/control-panel/partner/fields-active";
    }

    public partnerFieldSyncRulesList() {
        return "/control-panel/partner/fields-sync/list";
    }

    public partnerFieldSyncRules() {
        return "/control-panel/partner/fields-sync";
    }

    public partnerFieldListsList() {
        return "/control-panel/partner/fields-lists/list";
    }

    public partnerFieldLists() {
        return "/control-panel/partner/fields-lists";
    }

    public partnerFieldCategoriesActiveList() {
        return "/control-panel/partner/fields-categories";
    }

    public finPermissionsList() {
        return "/fin/permission/list";
    }

    public finPermissions() {
        return "/fin/permission";
    }

    public partnerFieldCategoriesList() {
        return "/control-panel/partner/fields-categories/list";
    }

    public partnerFieldCategories() {
        return "/control-panel/partner/fields-categories";
    }

    public partnerCalculatedGroupsList() {
        return "/control-panel/partner/calculated-group/list";
    }

    public partnerCalculatedGroups() {
        return "/control-panel/partner/calculated-group";
    }

    public partnerSearchColumnCategoriesList() {
        return "/control-panel/partner/search-column-category/list";
    }

    public partnerSearchColumnCategories() {
        return "/control-panel/partner/search-column-category";
    }

    public partnerSearchColumnsList() {
        return "/control-panel/partner/search-column/list";
    }

    public partnerSearchColumns() {
        return "/control-panel/partner/search-column";
    }

    public partnerSearchColumnTypesList() {
        return "/control-panel/partner/search-column-types";
    }

    public partnerSearchColumnGroupsList() {
        return "/control-panel/partner/search-column-groups";
    }

    public partnerColumnsCatalog() {
        return "/control-panel/partner/columns/catalog";
    }

    public partnerSearch() {
        return "/control-panel/partner/search";
    }

    public partnerSearchCities() {
        return "/partners/search/cities";
    }

    public partnerSearchLocalities() {
        return "/partners/search/localities";
    }

    public partnerSearchCountries() {
        return "/partners/search/countries";
    }

    public partnerCityAnalytics() {
        return "/control-panel/partner/search/city-analytics";
    }

    public partnerCityAnalyticsExport() {
        return "/control-panel/partner/search/city-analytics/export";
    }

    public partnerCityPartners(cityId: number) {
        return `/control-panel/partner/search/city/${cityId}/partners`;
    }

    public partnerByIds() {
        return "/control-panel/partner/search/partners-by-ids";
    }

    public partnerColumnSettings() {
        return "/control-panel/partner/user/columns";
    }

    public partnerFieldTypesList() {
        return "/control-panel/partner/fields-types";
    }

    public partnerPhysicalAddress() {
        return "/control-panel/partner/physical-address";
    }

    public partnerFirstEntry(partnerId: number | string) {
        return `/control-panel/partner/first-entry/${partnerId}`;
    }

    public partnerHistory(partnerId: number | string) {
        return `/control-panel/partner/${partnerId}/history`;
    }

    public settingsList() {
        return "/control-panel/settings/list";
    }

    public setting() {
        return "/control-panel/settings";
    }

    public ticketSettings() {
        return "/control-panel/ticket-settings";
    }

    public settingCategories() {
        return "/control-panel/settings/categories";
    }

    public settingFieldTypes() {
        return "/control-panel/settings/field-types";
    }

    public firstTestTypeList() {
        return "/control-panel/orders/firstTest/list";
    }

    public firstTestType() {
        return "/control-panel/orders/firstTest";
    }

    public publicFirstTestTypeList() {
        return "/control-panel/public-first-test";
    }

    public orderFormFieldRulesList() {
        return "/control-panel/orders/analysis-order-form-field-rule/list";
    }

    public orderFormFieldRules() {
        return "/control-panel/orders/analysis-order-form-field-rule";
    }
}
